import { FirebaseFirestore, FieldPath } from "@firebase/firestore-types";
import firebase from "firebase/compat/app";
import { getAuth, EmailAuthProvider } from "firebase/auth";
import "firebase/compat/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { getFirebaseConfig } from "~/configs/firebase";

if (!firebase.apps.length) {
  const config = getFirebaseConfig();
  firebase.initializeApp(config);
}

export const signInOptions = [EmailAuthProvider.PROVIDER_ID];
export const auth = getAuth();
export const db: FirebaseFirestore = firebase.firestore();
export const functions: firebase.functions.Functions = firebase
  .app()
  .functions("asia-northeast1");
export const documentId: FieldPath = firebase.firestore.FieldPath.documentId();
export const analytics = getAnalytics();
export const storage = firebase.storage();
export const currentUTCTime = firebase.firestore.Timestamp.now();

// Use if using firestore emulator
// if (location.hostname === "localhost") {
//   console.log("Using firestore emulator");
//   db.useEmulator("localhost", 8080);
// }
